<template>
  <div class="content-wrapper">
    <el-row :gutter="20">
      <el-col :span="4">
        <help-menu />
      </el-col>
      <el-col :span="20">
        <div class="help-content">
          <h2 class="help-title">订购流程</h2>
          <p class="help-paragraph">
            <img src="../../assets/images/help/help-process.jpg">
          </p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import HelpMenu from './components/help-menu'
export default {
  name: 'HelpProcess',
  components: {
    HelpMenu
  }
}
</script>

<style>

</style>
